<template>
  <a-modal :title="ModalTitle" v-model="visible" :confirmLoading="confirmLoading"
    cancelText="取消" okText="保存" width="525px"
    @ok="handleOk" @cancel="handleCancel">
    <a-form :form="form">
      <a-form-item v-for="(item, index) of formData" :key="index" 
        :label="item.label" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-input v-if="item.type === 'input'" v-decorator="[item.name, { rules: item.rules }]"/>
        <Distpicker v-if="item.type === 'distpicker'" @change="changeDist"/>
        <LMap v-if="item.type === 'map'" :valueData="mapValue"/>
        <a-rate v-if="item.type === 'rate'" allowHalf v-decorator="[item.name, { rules: item.rules }]"/>
        <div v-if="item.type === 'upload'" style="display: inline-block; position: relative;" @click="showImagesModal(item.name)">
          <div v-if="imageUrl">
            <LImg :src="imageUrl" style="width: 100px; height: 100px;"/>
            <div class="close" @click="closeImg($event)">&times;</div>
          </div>
          <a-button v-else type="dashed" icon="file-image">选择图片</a-button>
        </div>
        <div v-if="item.type === 'upload2'" style="display: inline-block; position: relative;">
          <a-button type="dashed" icon="file-image" @click="showImagesModal(item.name)">选择图片</a-button>
          <div style="display: flex; flex-wrap: wrap;">
            <div style="position: relative; margin: 0 10px 10px 0;" v-for="(img, index) of imageUrls" :key="index">
              <LImg :src="img" style="width: 100px; height: 100px;"/>
              <div class="close" @click="closeImg2($event, index)">&times;</div>
            </div>
          </div>
        </div> 
        <a-date-picker v-if="item.type === 'date'" style="width: 100%"  v-decorator="[item.name, { rules: item.rules }]" format="YYYY-MM-DD"/>
        <a-select v-else-if="item.type === 'select'" placeholder="请选择"
           v-decorator="[item.name, { rules: item.rules }]">
          <a-select-option v-for="(d, index) of seleteItems[item.items.data]" :key="index" :value="d[item.items.value]">{{ d[item.items.label] }}</a-select-option>
        </a-select>
        <a-textarea v-if="item.type === 'textarea'" v-decorator="[item.name, { rules: item.rules }]"/>
        <l-editor v-else-if="item.type === 'textarea2'" name="product_desc" :data="product_desc"/>
      </a-form-item>
    </a-form>
    <ImageModal v-if="imagesVisible"/>
  </a-modal>
</template>

<script>
const formData = [
  {
    name: 'product_id',
    label: '商品名称',
    type: 'select',
    rules: [{ required: true, message: '请输入供货商名称!' }],
    items: {
      data: 'product',
      label: 'product_name',
      value: 'product_id'
    }
  },
  {
    name: 'suppliers_id',
    label: '商品供应商',
    type: 'select',
    rules: [{ required: true, message: '请输入供应商备注!' }],
    items: {
      data: 'productSuppliers',
      label: 'suppliers_name',
      value: 'suppliers_id'
    }
  },
  {
    name: 'stock_price',
    label: '进货价格',
    type: 'input',
    rules: [{ required: false, message: '请输入进货价格!' }]
  },
  {
    name: 'stock_total',
    label: '进货数量',
    type: 'input',
    rules: [{ required: false, message: '请输入进货数量!' }]
  }
]
import C_ITEMS from '@/utils/items'
import moment from 'moment'
import url from '@/utils/URL'
import ImageModal from '@/views/modal/images'
import Distpicker from 'vue-distpicker'

export default {
  name: 'EditModal',
  inject: ['parent'],
  props: {
    item: Object
  },
  provide() {
    return {
      parent: this
    }
  },
  components: {
    ImageModal,
    Distpicker,
  },

  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 15 },
      ModalTitle: '新增供应商',
      visible: false,
      confirmLoading: false,
      formData,
      form: this.$form.createForm(this),
      seleteItems: {
        product:[],
        productSuppliers: [],
      },
      imageUrl: '',
      imageUrls: [],
      imageRoot: url.imageRoot,
      uploadParams: {},
      imagesVisible: false,
      imageKey: '',
      product_desc: '',
      editor: {},
      distData: {},
      mapValue: {},
      mapData: {}
    }
  },

  async created() {
    this.visible = true
    await this.$nextTick()
    await this.getProduct()
    await this.getProductSuppliers()
    if (this.item) {
      console.log(this.item)
      this.ModalTitle = '编辑供应商'
      // let item = await this.getDetail(this.item.cat_id)
      // let formFields = {}
      // for (let d of formData) {
      //   formFields[d.name] = item[d.name]
      // }
      this.form.setFieldsValue(this.item)
    }
  },

  beforeDestroy() {
    this.visible = false
  },

  methods: {
    async getProduct() {
      let res = await this.$store.dispatch('searchProductAction', {})
      this.seleteItems.product = res.data
    },
    async getProductSuppliers(){
      let res = await this.$store.dispatch('searchSuppliersAction', {})
      this.seleteItems.productSuppliers = res.data
    },
    async getDetail(cat_id) {
      let res = await this.$store.dispatch('storeProductCategoryDetailAction', {data: {cat_id}})
      return res.data
    },
    changeEditor(key, value) {
      this.editor[key] = value
    },
    changeDist(data) {
      this.distData = {
        province: data[0].name,
        city: data[1].name,
        district: data[2].name
      }
    },
    changeMap(data) {
      console.log(data)
      this.mapData = data
    },
    async handleOk() {
      this.confirmLoading=true;
      try {
        const { item, form } = this
        let params = await form.validateFields()
        if (params) {
          if (item) {
            params.suppliers_id = item.suppliers_id
          }
          let res = await this.$store.dispatch(item ? 'storeSuppliersUpdateAction' : 'storeSuppliersStockInAction', { data: params })
          if(res) {
            form.resetFields()
            this.parent.hideEditModal(1)
          }
        }
      } catch {
      }
			this.confirmLoading=false;
    },
    handleCancel() {
      this.parent.hideEditModal(0)
    },
    
    closeImg(e) {
      e.stopPropagation()
      this.imageUrl = ''
    },
    
    closeImg2(e, index) {
      e.stopPropagation()
      this.imageUrls.splice(index, 1)
    },

    showImagesModal(imageKey) {
      this.imageKey = imageKey
      this.imagesVisible = true
    },
    hideImagesModal(image) {
      if (image) {
        if (this.imageKey === 'cat_images') {
          this.imageUrls.push(image.path)
        } else {
          this.imageUrl = image.path
        }
      }
      this.imagesVisible = false
    },
  }
}
</script>
